/*=========================================================================================
  File Name: moduleRecueilActions.js
  Description: Recueil Module Actions
==========================================================================================*/


export default {
	SetHasChanges({
		commit
	}, payload) {
		commit('SET_HASCHANGES', payload);
	},
	AddToHasChanges({
		commit
	}, payload) {
		commit('ADD_TO_HASCHANGES', payload);
	},
	RemoveFromHasChanges({
		commit
	}, payload) {
		commit('REMOVE_FROM_HASCHANGES', payload);
	},
	ResetState({
		commit
	}) {
		commit('RESET_STATE');
	},
	SetDossierId({
		commit
	}, payload) {
		commit('SET_DOSSIERID', payload);
	},
	SetClientId({
		commit
	}, payload) {
		commit('SET_CLIENTID', payload);
	},
	SetCommentaireDossier({
		commit
	}, payload) {
		commit('SET_COMMENTAIREDOSSIER', payload);
	},
	SetDerDossier({
		commit
	}, payload) {
		commit('SET_DERDOSSIER', payload);
	},
	SetConformiteOrigineFonds({
		commit
	}, payload) {
		commit('SET_CONFORMITE_ORIGINEFONDS', payload);
	},
	SetConformiteObjetRelation({
		commit
	}, payload) {
		commit('SET_CONFORMITE_OBJETRELATION', payload);
	},
	SetConformiteCoherenceProfil({
		commit
	}, payload) {
		commit('SET_CONFORMITE_COHERENCEPROFIL', payload);
	},
	SetConformiteClientPresentRdv({
		commit
	}, payload) {
		commit('SET_CONFORMITE_CLIENTPRESENTRDV', payload);
	},
	SetFiscaliteIrppAcquitte({
		commit
	}, payload) {
		commit('SET_FISCALITE_IRPPACQUITTE', payload);
	},
	SetFiscaliteIfiAcquitte({
		commit
	}, payload) {
		commit('SET_FISCALITE_IFIACQUITTE', payload);
	},
	SetEtatCivilFirstName({
		commit
	}, payload) {
		commit('SET_ETATCIVIL_FIRSTNAME', payload);
	},
	SetEtatCivilLastName({
		commit
	}, payload) {
		commit('SET_ETATCIVIL_LASTNAME', payload);
	},
	SetEtatCivilBirthLastName({
		commit
	}, payload) {
		commit('SET_ETATCIVIL_BIRTHLASTNAME', payload);
	},
	SetEtatCivilCivility({
		commit
	}, payload) {
		commit('SET_ETATCIVIL_CIVILITY', payload);
	},
	SetEtatCivilDateOfBirth({
		commit
	}, payload) {
		commit('SET_ETATCIVIL_DATEOFBIRTH', payload);
	},
	SetEtatCivilBirthCity({
		commit
	}, payload) {
		commit('SET_ETATCIVIL_BIRTHCITY', payload);
	},
	SetEtatCivilBirthState({
		commit
	}, payload) {
		commit('SET_ETATCIVIL_BIRTHSTATE', payload);
	},
	SetEtatCivilBirthDeptNum({
		commit
	}, payload) {
		commit('SET_ETATCIVIL_BIRTHDEPTNUM', payload);
	},
	SetEtatCivilBirthCountry({
		commit
	}, payload) {
		commit('SET_ETATCIVIL_BIRTHCOUNTRY', payload);
	},
	SetEtatCivilNationality({
		commit
	}, payload) {
		commit('SET_ETATCIVIL_NATIONALITY', payload);
	},
	SetEtatCivilIsParentIsole({
		commit
	}, payload) {
		commit('SET_ETATCIVIL_ISPARENTISOLE', payload);
	},
	SetEtatCivilIsAncienCombattant({
		commit
	}, payload) {
		commit('SET_ETATCIVIL_ISANCIENCOMBATTANT', payload);
	},
	SetEtatCivilIsHandicape({
		commit
	}, payload) {
		commit('SET_ETATCIVIL_ISHANDICAPE', payload);
	},
	SetConjointEtatCivilIsAncienCombattant({
		commit
	}, payload) {
		commit('SET_CONJOINT_ETATCIVIL_ISANCIENCOMBATTANT', payload);
	},
	SetConjointEtatCivilIsHandicape({
		commit
	}, payload) {
		commit('SET_CONJOINT_ETATCIVIL_ISHANDICAPE', payload);
	},
	SetContactInfoAddress({
		commit
	}, payload) {
		commit('SET_CONTACTINFO_ADDRESS', payload);
	},
	SetContactInfoAddressComp({
		commit
	}, payload) {
		commit('SET_CONTACTINFO_ADDRESSCOMP', payload);
	},
	SetContactInfoZipCode({
		commit
	}, payload) {
		commit('SET_CONTACTINFO_ZIPCODE', payload);
	},
	SetContactInfoCity({
		commit
	}, payload) {
		commit('SET_CONTACTINFO_CITY', payload);
	},
	SetContactInfoCountry({
		commit
	}, payload) {
		commit('SET_CONTACTINFO_COUNTRY', payload);
	},
	SetContactInfoPersoEmail({
		commit
	}, payload) {
		commit('SET_CONTACTINFO_PERSOEMAIL', payload);
	},
	SetContactInfoProEmail({
		commit
	}, payload) {
		commit('SET_CONTACTINFO_PROEMAIL', payload);
	},
	SetContactInfoCellPhone({
		commit
	}, payload) {
		commit('SET_CONTACTINFO_CELLPHONE', payload);
	},
	SetContactInfoProPhone({
		commit
	}, payload) {
		commit('SET_CONTACTINFO_PROPHONE', payload);
	},
	SetContactInfoPersoPhone({
		commit
	}, payload) {
		commit('SET_CONTACTINFO_PERSOPHONE', payload);
	},
	SetContactInfoCellPhoneFormatted({
		commit
	}, payload) {
		commit('SET_CONTACTINFO_CELLPHONEFORMATTED', payload);
	},
	SetContactInfoCellPhoneCountryVal({
		commit
	}, payload) {
		commit('SET_CONTACTINFO_CELLPHONECOUNTRYVAL', payload);
	},
	SetContactInfoProPhoneFormatted({
		commit
	}, payload) {
		commit('SET_CONTACTINFO_PROPHONEFORMATTED', payload);
	},
	SetContactInfoProPhoneCountryVal({
		commit
	}, payload) {
		commit('SET_CONTACTINFO_PROPHONECOUNTRYVAL', payload);
	},
	SetContactInfoPersoPhoneFormatted({
		commit
	}, payload) {
		commit('SET_CONTACTINFO_PERSOPHONEFORMATTED', payload);
	},
	SetContactInfoPersoPhoneCountryVal({
		commit
	}, payload) {
		commit('SET_CONTACTINFO_PERSOPHONECOUNTRYVAL', payload);
	},
	SetSituationFamilialeFamSituation({
		commit
	}, payload) {
		commit('SET_SITUATIONFAMILIALE_FAMSITUATION', payload);
	},
	SetSituationFamilialeRegimeMatrimonial({
		commit
	}, payload) {
		commit('SET_SITUATIONFAMILIALE_REGIMEMATRIMONIAL', payload);
	},
	SetSituationFamilialeRegimePacs({
		commit
	}, payload) {
		commit('SET_SITUATIONFAMILIALE_REGIMEPACS', payload);
	},
	SetSituationFamilialeHasRegimeMatrimonial({
		commit
	}, payload) {
		commit('SET_SITUATIONFAMILIALE_HASREGIMEMATRIMONIAL', payload);
	},
	SetSituationFamilialeHasRegimePacs({
		commit
	}, payload) {
		commit('SET_SITUATIONFAMILIALE_HASREGIMEPACS', payload);
	},
	SetSituationFamilialeHasConjoint({
		commit
	}, payload) {
		commit('SET_SITUATIONFAMILIALE_HASCONJOINT', payload);
	},
	SetSocioProCat({
		commit
	}, payload) {
		commit('SET_SOCIOPROCAT', payload);
	},
	SetProfessionLibelle({
		commit
	}, payload) {
		commit('SET_PROFESSIONLIBELLE', payload);
	},
	SetConjointEtatCivilFirstName({
		commit
	}, payload) {
		commit('SET_CONJOINT_ETATCIVIL_FIRSTNAME', payload);
	},
	SetConjointEtatCivilLastName({
		commit
	}, payload) {
		commit('SET_CONJOINT_ETATCIVIL_LASTNAME', payload);
	},
	SetConjointEtatCivilBirthLastName({
		commit
	}, payload) {
		commit('SET_CONJOINT_ETATCIVIL_BIRTHLASTNAME', payload);
	},
	SetConjointEtatCivilCivility({
		commit
	}, payload) {
		commit('SET_CONJOINT_ETATCIVIL_CIVILITY', payload);
	},
	SetConjointEtatCivilDateOfBirth({
		commit
	}, payload) {
		commit('SET_CONJOINT_ETATCIVIL_DATEOFBIRTH', payload);
	},
	SetConjointEtatCivilBirthCIty({
		commit
	}, payload) {
		commit('SET_CONJOINT_ETATCIVIL_BIRTHCITY', payload);
	},
	SetConjointEtatCivilBirthState({
		commit
	}, payload) {
		commit('SET_CONJOINT_ETATCIVIL_BIRTHSTATE', payload);
	},
	SetConjointEtatCivilBirthDeptNum({
		commit
	}, payload) {
		commit('SET_CONJOINT_ETATCIVIL_BIRTHDEPTNUM', payload);
	},
	SetConjointEtatCivilBirthCountry({
		commit
	}, payload) {
		commit('SET_CONJOINT_ETATCIVIL_BIRTHCOUNTRY', payload);
	},
	SetConjointEtatCivilNationality({
		commit
	}, payload) {
		commit('SET_CONJOINT_ETATCIVIL_NATIONALITY', payload);
	},
	SetConjointSocioProCat({
		commit
	}, payload) {
		commit('SET_CONJOINT_SOCIOPROCAT', payload);
	},
	SetConjointProfessionLibelle({
		commit
	}, payload) {
		commit('SET_CONJOINT_PROFESSIONLIBELLE', payload);
	},
	SetConjointContactInfoPersoEmail({
		commit
	}, payload) {
		commit('SET_CONJOINT_CONTACTINFO_PERSOEMAIL', payload);
	},
	SetConjointContactInfoProEmail({
		commit
	}, payload) {
		commit('SET_CONJOINT_CONTACTINFO_PROEMAIL', payload);
	},
	SetConjointContactInfoCellPhone({
		commit
	}, payload) {
		commit('SET_CONJOINT_CONTACTINFO_CELLPHONE', payload);
	},
	SetConjointContactInfoProPhone({
		commit
	}, payload) {
		commit('SET_CONJOINT_CONTACTINFO_PROPHONE', payload);
	},
	SetConjointContactInfoPersoPhone({
		commit
	}, payload) {
		commit('SET_CONJOINT_CONTACTINFO_PERSOPHONE', payload);
	},
	SetConjointContactInfoCellPhoneFormatted({
		commit
	}, payload) {
		commit('SET_CONJOINT_CONTACTINFO_CELLPHONEFORMATTED', payload);
	},
	SetConjointContactInfoProPhoneFormatted({
		commit
	}, payload) {
		commit('SET_CONJOINT_CONTACTINFO_PROPHONEFORMATTED', payload);
	},
	SetConjointContactInfoPersoPhoneFormatted({
		commit
	}, payload) {
		commit('SET_CONJOINT_CONTACTINFO_PERSOPHONEFORMATTED', payload);
	},
	SetConjointContactInfoCellPhoneCountryVal({
		commit
	}, payload) {
		commit('SET_CONJOINT_CONTACTINFO_CELLPHONECOUNTRYVAL', payload);
	},
	SetConjointContactInfoProPhoneCountryVal({
		commit
	}, payload) {
		commit('SET_CONJOINT_CONTACTINFO_PROPHONECOUNTRYVAL', payload);
	},
	SetConjointContactInfoPersoPhoneCountryVal({
		commit
	}, payload) {
		commit('SET_CONJOINT_CONTACTINFO_PERSOPHONECOUNTRYVAL', payload);
	},
	SetAvantagesMatrimoniauxAttributionBiensCommuns({
		commit
	}, payload) {
		commit('SET_AVANTAGESMATRIMONIAUX_ATTRIBUTIONBIENSCOMMUNS', payload);
	},
	SetHeritiers({
		commit
	}, payload) {
		commit('SET_HERITIERS', payload);
	},
	AddToHeritiers({
		commit
	}, payload) {
		commit('ADD_TO_HERITIERS', payload);
	},
	RemoveFromHeritiers({
		commit
	}, payload) {
		commit('REMOVE_FROM_HERITIERS', payload);
	},
	EditHeritier({
		commit
	}, payload) {
		commit('EDIT_HERITIER', payload);
	},
	EditRevenu({
		commit
	}, payload) {
		commit('EDIT_REVENU', payload);
	},
	EditCharge({
		commit
	}, payload) {
		commit('EDIT_CHARGE', payload);
	},
	EditLiberalite({
		commit
	}, payload) {
		commit('EDIT_LIBERALITE', payload);
	},
	EditActif({
		commit
	}, payload) {
		commit('EDIT_ACTIF', payload);
	},
	EditPassif({
		commit
	}, payload) {
		commit('EDIT_PASSIF', payload);
	},
	SetLiberalites({
		commit
	}, payload) {
		commit('SET_LIBERALITES', payload);
	},
	AddToLiberalites({
		commit
	}, payload) {
		commit('ADD_TO_LIBERALITES', payload);
	},
	RemoveFromLiberalites({
		commit
	}, payload) {
		commit('REMOVE_FROM_LIBERALITES', payload);
	},
	SetActifs({
		commit
	}, payload) {
		commit('SET_ACTIFS', payload);
	},
	AddToActifs({
		commit
	}, payload) {
		commit('ADD_TO_ACTIFS', payload);
	},
	RemoveFromActifs({
		commit
	}, payload) {
		commit('REMOVE_FROM_ACTIFS', payload);
	},
	SetPassifs({
		commit
	}, payload) {
		commit('SET_PASSIFS', payload);
	},
	AddToPassifs({
		commit
	}, payload) {
		commit('ADD_TO_PASSIFS', payload);
	},
	RemoveFromPassifs({
		commit
	}, payload) {
		commit('REMOVE_FROM_PASSIFS', payload);
	},
	SetRevenus({
		commit
	}, payload) {
		commit('SET_REVENUS', payload);
	},
	AddToRevenus({
		commit
	}, payload) {
		commit('ADD_TO_REVENUS', payload);
	},
	RemoveFromRevenus({
		commit
	}, payload) {
		commit('REMOVE_FROM_REVENUS', payload);
	},
	SetObjectifs({
		commit
	}, payload) {
		commit('SET_OBJECTIFS', payload);
	},
	AddToObjectifs({
		commit
	}, payload) {
		commit('ADD_TO_OBJECTIFS', payload);
	},
	RemoveFromObjectifs({
		commit
	}, payload) {
		commit('REMOVE_FROM_OBJECTIFS', payload);
	},
	SetCharges({
		commit
	}, payload) {
		commit('SET_CHARGES', payload);
	},
	AddToCharges({
		commit
	}, payload) {
		commit('ADD_TO_CHARGES', payload);
	},
	RemoveFromCharges({
		commit
	}, payload) {
		commit('REMOVE_FROM_CHARGES', payload);
	},
	SetPrevoyanceDeces({
		commit
	}, payload) {
		commit('SET_PREVOYANCE_DECES', payload);
	},
	AddToPrevoyanceDeces({
		commit
	}, payload) {
		commit('ADD_TO_PREVOYANCE_DECES', payload);
	},
	RemoveFromPrevoyanceDeces({
		commit
	}, payload) {
		commit('REMOVE_FROM_PREVOYANCE_DECES', payload);
	},
	SetPrevoyanceIncapaciteTemp({
		commit
	}, payload) {
		commit('SET_PREVOYANCE_INCAPACITETEMP', payload);
	},
	AddToPrevoyanceIncapaciteTemp({
		commit
	}, payload) {
		commit('ADD_TO_PREVOYANCE_INCAPACITETEMP', payload);
	},
	RemoveFromPrevoyanceIncapaciteTemp({
		commit
	}, payload) {
		commit('REMOVE_FROM_PREVOYANCE_INCAPACITETEMP', payload);
	},

	SetPrevoyanceTypeClientIndivIncapaciteTemp({
		commit
	}, payload) {
		commit('SET_PREVOYANCE_TYPECLIENTINDIVINCAPACITETEMP', payload);
	},
	SetPrevoyanceTypeClientCollectifIncapaciteTemp({
		commit
	}, payload) {
		commit('SET_PREVOYANCE_TYPECLIENTCOLLECTIFINCAPACITETEMP', payload);
	},
	SetPrevoyanceTypeConjointIndivIncapaciteTemp({
		commit
	}, payload) {
		commit('SET_PREVOYANCE_TYPECONJOINTINDIVINCAPACITETEMP', payload);
	},
	SetPrevoyanceTypeConjointCollectifIncapaciteTemp({
		commit
	}, payload) {
		commit('SET_PREVOYANCE_TYPECONJOINTCOLLECTIFINCAPACITETEMP', payload);
	},
	SetPrevoyanceIncapacitePerm({
		commit
	}, payload) {
		commit('SET_PREVOYANCE_INCAPACITEPERM', payload);
	},
	AddToPrevoyanceIncapacitePerm({
		commit
	}, payload) {
		commit('ADD_TO_PREVOYANCE_INCAPACITEPERM', payload);
	},
	RemoveFromPrevoyanceIncapacitePerm({
		commit
	}, payload) {
		commit('REMOVE_FROM_PREVOYANCE_INCAPACITEPERM', payload);
	},
	SetPrevoyanceTypeClientIndivIncapacitePerm({
		commit
	}, payload) {
		commit('SET_PREVOYANCE_TYPECLIENTINDIVINCAPACITEPERM', payload);
	},
	SetPrevoyanceTypeClientCollectifIncapacitePerm({
		commit
	}, payload) {
		commit('SET_PREVOYANCE_TYPECLIENTCOLLECTIFINCAPACITEPERM', payload);
	},
	SetPrevoyanceTypeConjointIndivIncapacitePerm({
		commit
	}, payload) {
		commit('SET_PREVOYANCE_TYPECONJOINTINDIVINCAPACITEPERM', payload);
	},
	SetPrevoyanceTypeConjointCollectifIncapacitePerm({
		commit
	}, payload) {
		commit('SET_PREVOYANCE_TYPECONJOINTCOLLECTIFINCAPACITEPERM', payload);
	},
	SetPrevoyanceTypeClientIndivIncapacitePermCat({
		commit
	}, payload) {
		commit('SET_PREVOYANCE_TYPECLIENTINDIVINCAPACITEPERMCAT', payload);
	},
	SetPrevoyanceTypeClientCollectifIncapacitePermCat({
		commit
	}, payload) {
		commit('SET_PREVOYANCE_TYPECLIENTCOLLECTIFINCAPACITEPERMCAT', payload);
	},
	SetPrevoyanceTypeConjointIndivIncapacitePermCat({
		commit
	}, payload) {
		commit('SET_PREVOYANCE_TYPECONJOINTINDIVINCAPACITEPERMCAT', payload);
	},
	SetPrevoyanceTypeConjointCollectifIncapacitePermCat({
		commit
	}, payload) {
		commit('SET_PREVOYANCE_TYPECONJOINTCOLLECTIFINCAPACITEPERMCAT', payload);
	},
	SetPrevoyanceDependanceRenteMensuelleClient({
		commit
	}, payload) {
		commit('SET_PREVOYANCE_DEPENDANCE_RENTEMENSUELLECLIENT', payload);
	},
	SetPrevoyanceDependanceRenteMensuelleConjoint({
		commit
	}, payload) {
		commit('SET_PREVOYANCE_DEPENDANCE_RENTEMENSUELLECONJOINT', payload);
	},
	SetAvantagesMatrimoniauxAuProfitConjointCreanceParticipation({
		commit
	}, payload) {
		commit('SET_AVANTAGESMATRIMONIAUX_AUPROFITCONJOINTCREANCEPARTICIPATION', payload);
	},
	SetAvantagesMatrimoniauxAuProfitClientCreanceParticipation({
		commit
	}, payload) {
		commit('SET_AVANTAGESMATRIMONIAUX_AUPROFITCLIENTCREANCEPARTICIPATION', payload);
	},
	SetAvantagesMatrimoniauxDettesConjointEnversClient({
		commit
	}, payload) {
		commit('SET_AVANTAGESMATRIMONIAUX_DETTESCONJOINTENVERSCLIENT', payload);
	},
	SetAvantagesMatrimoniauxDettesClientEnversConjoint({
		commit
	}, payload) {
		commit('SET_AVANTAGESMATRIMONIAUX_DETTESCLIENTENVERSCONJOINT', payload);
	},
	SetAvantagesMatrimoniauxAuProfitConjointLegsUsurfruit({
		commit
	}, payload) {
		commit('SET_AVANTAGESMATRIMONIAUX_AUPROFITCONJOINTLEGSUSURFRUIT', payload);
	},
	SetAvantagesMatrimoniauxAuProfitConjointLegsMontant({
		commit
	}, payload) {
		commit('SET_AVANTAGESMATRIMONIAUX_AUPROFITCONJOINTLEGSMONTANT', payload);
	},
	SetAvantagesMatrimoniauxAuProfitConjointLegs({
		commit
	}, payload) {
		commit('SET_AVANTAGESMATRIMONIAUX_AUPROFITCONJOINTLEGS', payload);
	},
	SetAvantagesMatrimoniauxAuProfitClientLegsUsurfruit({
		commit
	}, payload) {
		commit('SET_AVANTAGESMATRIMONIAUX_AUPROFITCLIENTLEGSUSURFRUIT', payload);
	},
	SetAvantagesMatrimoniauxAuProfitClientLegsMontant({
		commit
	}, payload) {
		commit('SET_AVANTAGESMATRIMONIAUX_AuProfitClientLegsMontant', payload);
	},
	SetAvantagesMatrimoniauxAuProfitClientLegs({
		commit
	}, payload) {
		commit('SET_AVANTAGESMATRIMONIAUX_AUPROFITCLIENTLEGS', payload);
	},
	SetAvantagesMatrimoniauxAuProfitConjointDonationAnterieur({
		commit
	}, payload) {
		commit('SET_AVANTAGESMATRIMONIAUX_AUPROFITCONJOINTDONATIONANTERIEUR', payload);
	},
	SetAvantagesMatrimoniauxAuProfitClientDonationAnterieur({
		commit
	}, payload) {
		commit('SET_AVANTAGESMATRIMONIAUX_AUPROFITCLIENTDONATIONANTERIEUR', payload);
	},
	SetAvantagesMatrimoniauxDuesParCommunauteAuConjoint({
		commit
	}, payload) {
		commit('SET_AVANTAGESMATRIMONIAUX_DUESPARCOMMUNAUTEAUCONJOINT', payload);
	},
	SetAvantagesMatrimoniauxDuesParCommunauteAuClient({
		commit
	}, payload) {
		commit('SET_AVANTAGESMATRIMONIAUX_DUESPARCOMMUNAUTEAUCLIENT', payload);
	},
	SetAvantagesMatrimoniauxDuesParConjointBeneficeCommunaute({
		commit
	}, payload) {
		commit('SET_AVANTAGESMATRIMONIAUX_DUESPARCONJOINTBENEFICECOMMUNAUTE', payload);
	},
	SetAvantagesMatrimoniauxDuesParClientBeneficeCommunaute({
		commit
	}, payload) {
		commit('SET_AVANTAGESMATRIMONIAUX_DUESPARCLIENTBENEFICECOMMUNAUTE', payload);
	},
	SetAvantagesMatrimoniauxAuProfitConjointDonationsEntreVifs({
		commit
	}, payload) {
		commit('SET_AVANTAGESMATRIMONIAUX_AUPROFITCONJOINTDONATIONSENTREVIFS', payload);
	},
	SetAvantagesMatrimoniauxAuProfitClientDonationsEntreVifs({
		commit
	}, payload) {
		commit('SET_AVANTAGESMATRIMONIAUX_AUPROFITCLIENTDONATIONSENTREVIFS', payload);
	},
	SetAvantagesMatrimoniauxAuProfitConjointDonationDernierVivant({
		commit
	}, payload) {
		commit('SET_AVANTAGESMATRIMONIAUX_AUPROFITCONJOINTDONATIONDERNIERVIVANT', payload);
	},
	SetAvantagesMatrimoniauxAuProfitClientDonationDernierVivant({
		commit
	}, payload) {
		commit('SET_AVANTAGESMATRIMONIAUX_AUPROFITCLIENTDONATIONDERNIERVIVANT', payload);
	},
	SetAvantagesMatrimoniauxIsClausePreciputAuProfitConjoint({
		commit
	}, payload) {
		commit('SET_AVANTAGESMATRIMONIAUX_ISCLAUSEPRECIPUTAUPROFITCONJOINT', payload);
	},
	SetAvantagesMatrimoniauxIsClausePreciputAuProfitClient({
		commit
	}, payload) {
		commit('SET_AVANTAGESMATRIMONIAUX_ISCLAUSEPRECIPUTAUPROFITCLIENT', payload);
	},
	SetAvantagesMatrimoniauxAvantagesMatrimoniauxCommentaires({
		commit
	}, payload) {
		commit('SET_AVANTAGESMATRIMONIAUX_AVANTAGESMATRIMONIAUXCOMMENTAIRES', payload);
	},
	SetAvantagesMatrimoniauxAutresBiensConjoint({
		commit
	}, payload) {
		commit('SET_AVANTAGESMATRIMONIAUX_AUTRESBIENSCONJOINT', payload);
	},
	SetAvantagesMatrimoniauxAutresBiensClient({
		commit
	}, payload) {
		commit('SET_AVANTAGESMATRIMONIAUX_AUTRESBIENSCLIENT', payload);
	},
	SetAvantagesMatrimoniauxMontantAuProfitConjointAssuranceNonDenouees({
		commit
	}, payload) {
		commit('SET_AVANTAGESMATRIMONIAUX_MONTANTAUPROFITCONJOINTASSURANCENONDENOUEES', payload);
	},
	SetAvantagesMatrimoniauxMontantAuProfitClientAssuranceNonDenouees({
		commit
	}, payload) {
		commit('SET_AVANTAGESMATRIMONIAUX_MONTANTAUPROFITCLIENTASSURANCENONDENOUEES', payload);
	},
	SetAvantagesMatrimoniauxAuProfitConjointAssuranceNonDenouees({
		commit
	}, payload) {
		commit('SET_AVANTAGESMATRIMONIAUX_AUPROFITCONJOINTASSURANCENONDENOUEES', payload);
	},
	SetAvantagesMatrimoniauxAuProfitClientAssuranceNonDenouees({
		commit
	}, payload) {
		commit('SET_AVANTAGESMATRIMONIAUX_AUPROFITCLIENTASSURANCENONDENOUEES', payload);
	},
	SetRecueil({
		commit
	}, payload) {
		commit('SET_RECUEIL', payload);
	},
	SetResidenceFiscaleAdresseFiscaleSame({
		commit
	}, payload) {
		commit('SET_RESIDENCEFISCALE_ADRESSEFISCALESAME', payload);
	},
	SetResidenceFiscaleContactInfoAddress({
		commit
	}, payload) {
		commit('SET_RESIDENCEFISCALE_CONTACTINFO_ADDRESS', payload);
	},
	SetResidenceFiscaleContactInfoAddressComp({
		commit
	}, payload) {
		commit('SET_RESIDENCEFISCALE_CONTACTINFO_ADDRESSCOMP', payload);
	},
	SetResidenceFiscaleContactInfoZipCode({
		commit
	}, payload) {
		commit('SET_RESIDENCEFISCALE_CONTACTINFO_ZIPCODE', payload);
	},
	SetResidenceFiscaleContactInfoCity({
		commit
	}, payload) {
		commit('SET_RESIDENCEFISCALE_CONTACTINFO_CITY', payload);
	},
	SetResidenceFiscaleContactInfoCountry({
		commit
	}, payload) {
		commit('SET_RESIDENCEFISCALE_CONTACTINFO_COUNTRY', payload);
	},
	SetConjointResidenceFiscaleAdresseFiscaleSame({
		commit
	}, payload) {
		commit('SET_CONJOINT_RESIDENCEFISCALE_ADRESSEFISCALESAME', payload);
	},
	SetConjointResidenceFiscaleContactInfoAddress({
		commit
	}, payload) {
		commit('SET_CONJOINT_RESIDENCEFISCALE_CONTACTINFO_ADDRESS', payload);
	},
	SetConjointResidenceFiscaleContactInfoAddressComp({
		commit
	}, payload) {
		commit('SET_CONJOINT_RESIDENCEFISCALE_CONTACTINFO_ADDRESSCOMP', payload);
	},
	SetConjointResidenceFiscaleContactInfoZipCode({
		commit
	}, payload) {
		commit('SET_CONJOINT_RESIDENCEFISCALE_CONTACTINFO_ZIPCODE', payload);
	},
	SetConjointResidenceFiscaleContactInfoCity({
		commit
	}, payload) {
		commit('SET_CONJOINT_RESIDENCEFISCALE_CONTACTINFO_CITY', payload);
	},
	SetConjointResidenceFiscaleContactInfoCountry({
		commit
	}, payload) {
		commit('SET_CONJOINT_RESIDENCEFISCALE_CONTACTINFO_COUNTRY', payload);
	},
};